import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { CircularProgress } from '@material-ui/core'
import { useClientStatusTemplateAssignment } from '../../../../../api/groups'
import SydButton from '../../../../commonDesign/Button'
import SydLinkButton from '../../../../commonDesign/LinkButton'
import { ADMIN_ROUTES } from '../../../../../constants'

function StatusReportEmpty ({
  onTriggerNewReport
}) {
  const { levelId, statusTemplateId } = useParams()

  const { data: assignments, isLoading: assignmentLoading } = useClientStatusTemplateAssignment(levelId)

  const clientIsAssigned = useMemo(() => assignments?.statusTemplateIds?.some(id => id === Number(statusTemplateId)),
    [assignments, statusTemplateId])

  if (assignmentLoading) {
    return (
      <div className='my-5 gap-5 flex flex-col items-center justify-center'>
        <CircularProgress />
        <span className='font-size-lg'>
          Loading
        </span>
      </div>
    )
  }

  if (clientIsAssigned) {
    return (
      <div className='flex flex-col items-center justify-center gap-5 my-5'>
        <div className='font-size-lg'>Client does not have a report run yet</div>
        <div>
          <SydButton variant='primary' onClick={onTriggerNewReport}>
            Run New Report
          </SydButton>
        </div>
      </div>
    )
  }

  if (!clientIsAssigned) {
    return (
      <div className='flex flex-col items-center justify-center gap-5'>
        {JSON.stringify(assignments?.statusTemplateIds)}
        <div className='font-size-lg'>Client is not assigned to this status template</div>
        <SydLinkButton to={ADMIN_ROUTES.STATUS_REPORTS.ASSIGNMENTS.HOME} variant='primary'>
          View Assignments
        </SydLinkButton>
      </div>
    )
  }
}

StatusReportEmpty.propTypes = {
  onTriggerNewReport: PropTypes.func.isRequired
}

export default StatusReportEmpty
